import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import * as CryptoJS from 'crypto-js';
import {Globals} from '.././globals';



@Injectable()
export class contentService {
   user:any;
   reqHeader = new HttpHeaders({ 'No-Auth':'True'});

  constructor(private http: HttpClient,private _global:Globals) {
    if(localStorage.getItem('_ur')){
     var bytes  = CryptoJS.AES.decrypt(localStorage.getItem('_ur'), this._global.secretKey);
     this.user = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
  }
  readonly rootUrl = this._global.siteUrl;
  

  adddoc(formObj){
    formObj['docType']='pdf';
    formObj['createdby']=this.user.id;
    return this.http.post(this.rootUrl + 'content/adddoc', formObj);
  }

  adddocDownload(formObj){
    formObj['createdby']=this.user.id;
    return this.http.post(this.rootUrl + 'content/adddoccontent', formObj);
  }

  getdoc(doc){
    var obj={};
    obj['postId']=doc;
    return this.http.post(this.rootUrl + 'content/getdoc', obj);
  }

  addpermission(formObj){
    return this.http.post(this.rootUrl + 'content/addpermission', formObj);
  }

  getposttopic(category){
    const body = {
      category: category,
    }
   // var formObj = {};
    //formObj['user']=this.user.id;
    return this.http.post(this.rootUrl + 'content/getposttopic',body,{ headers: this.reqHeader});
  }


  getdownloadContent(obj){
      return this.http.post(this.rootUrl + 'content/getdownloadcontent',obj,{ headers: this.reqHeader});
  }

  getdownloadContentbydocId(obj){
      return this.http.post(this.rootUrl + 'content/getmaterial',obj);
  }

  delAttachemet(docId){
    var obj={};
    obj['attachedId']=docId;
    return this.http.post(this.rootUrl + 'content/delattachemet', obj)
  }


  deldownloadContent(obj){
    return this.http.post(this.rootUrl + 'content/delcnt', obj)
  }
  savePostLike(Obj){
    return this.http.post(this.rootUrl + 'content/savepostlike', Obj); 
  }
  bookmark(Obj){
    return this.http.post(this.rootUrl + 'content/bookmark', Obj);  
  }
  
  iaminterested(obj){
    return this.http.post(this.rootUrl + 'content/iaminterest', obj)
  }

  rankplist(pgObj){
    const body = {
      start:pgObj[0],
      end:pgObj[1],
      search:pgObj[2],
      user:pgObj[3],
     }
     return this.http.post(this.rootUrl + 'content/rankplist',body);
   
   }

   addrankPredictor(Obj){
    return this.http.post(this.rootUrl + 'content/addrank', Obj);
   
   }
   updaterankPredictor(Obj){
    return this.http.post(this.rootUrl + 'content/updaterank', Obj);
   }

   editrank(Id){
    const body = {
      id:btoa(Id)
     }
     return this.http.post(this.rootUrl + 'content/getrankdetails', body,{ headers: this.reqHeader});
   
   }

   rankfrontplist(obj){
    return this.http.post(this.rootUrl + 'content/getrankfrontplist',obj,{ headers: this.reqHeader});
   }

}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/content.service.ts